<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.category }}
      </h2>
      <div class="innerContent" ref="categoryContent">
        <div v-if="!isSelect" class="addCategory">
          <button type="button" class="btn btnWhite btnAdd" @click="addCategory"></button>
          <!-- <button type="button" class="btn btnWhite">외부 데이터 연동</button> -->
        </div>
        <ShopCategoryTree
          :locale="locale"
          :list="list"
          :defaultLang="defaultLang"
          :isBaseShopPos="isBaseShopPos"
          :isSelect="isSelect"
          :checkedIds="localCheckedIds"
          :disabledIds="disabledIds"
          @removeItem="removeItem"
          @setItem="setCategorySetting"
          @checkCategory="checkCategory"
          @setLanguage="setLanguage" />
      </div>
      <div v-if="!isSelect" class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="save">{{ locale.save }}</button>
      </div>
      <div v-else class="btns">
        <button type="button" class="btn btnRed btnLeft sizeS" @click="setUnknown">{{ locale.clear }}</button>
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="closeLanguage" />
    <!-- //언어별 세팅 -->
    <!-- 카테고리 세팅 -->
    <ShopCategorySetting v-if="categorySetting"
      :locale="locale"
      :pageId="id"
      :catCode="catCode"
      :categoryId="categorySetting"
      :defaultLang="defaultLang"
      @close="setCategorySetting(null)" />
    <!-- //카테고리 세팅 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import ShopCategoryTree from './ShopCategoryTree'
import ShopCategorySetting from './ShopCategorySetting'
import LangValue from '@/components/Util/LangValue'

export default {
  name: 'ShopCategory',
  props: [
    'locale',
    'id',
    'catCode',
    'category',
    'defaultLang',
    'isBaseShopPos',
    'isSelect', // 편집이 아닌 선택
    'checkedIds', // 선택된 카테고리 ids
    'disabledIds' // 변경 불가한 카테고리 ids
  ],
  components: {
    ShopCategoryTree,
    ShopCategorySetting,
    LangValue
  },
  computed: {
    isValid () {
      const list = this.list
      const listLength = list.length > 0
      return listLength
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      list: [],
      localCheckedIds: [],
      langTarget: null,
      langValueLayer: false,
      langValue: {},
      categorySetting: null,
      ids: []
    }
  },
  methods: {
    async init () {
      const category = this.category || []
      const filteredCategory = category.filter(item => item.categoryId !== 'call-staff' && item.categoryId !== 'unknown')
      this.list = this._.cloneDeep(filteredCategory)
      this.localCheckedIds = this._.cloneDeep(this.checkedIds || [])
    },
    close () {
      this.$emit('close')
    },
    addCategory () {
      this.list.push({
        categoryId: UNIQUE.uniqueId8(),
        categoryLabel: LANG.valueObj('')
      })
      this.$nextTick(() => {
        const categoryContent = this.$refs.categoryContent
        if (categoryContent) {
          categoryContent.scrollTop = categoryContent.scrollHeight
        }
      })
    },
    setCategorySetting (categoryId) {
      this.categorySetting = categoryId || null
    },
    setLanguage (categoryId, categoryLabel) {
      const fillLangs = UTIL.fillLangs(categoryLabel, categoryLabel[this.defaultLang])
      categoryLabel = fillLangs
      this.langTarget = categoryId
      this.langValueLayer = true
      this.langValue = categoryLabel
    },
    closeLanguage () {
      const categoryId = this.langTarget
      const targetItem = findCategoryItem(this.list, categoryId)
      function findCategoryItem(array, categoryId) {
        for (const item of array) {
          if (item.categoryId === categoryId) {
            return item
          }
          if (item.subCategory && Array.isArray(item.subCategory)) {
            const found = findCategoryItem(item.subCategory, categoryId)
            if (found) {
              return found
            }
          }
        }
        return null
      }
      if (targetItem) {
        targetItem.categoryLabel = this.langValue
      }
      this.langTarget = null
      this.langValueLayer = false
      this.langValue = {}
    },
    setUnknown () {
      this.checkCategory(['unknown'])
    },
    checkCategory (ids) {
        this.localCheckedIds = ids.filter(id => id !== 'unknown')
    },
    removeItem (categoryId) {
      this.list = this.list.filter(x => {
        return x.categoryId!== categoryId
      }).map(x => {
        return {
          ...x,
          ...x.subCategory && {
            subCategory: x.subCategory.filter(c => c.categoryId !== categoryId)
          }
        }
      })
    },
    apply () {
      this.$emit('apply', this.localCheckedIds)
      this.close()
    },
    async save () {
      const res = await this.$store.dispatch('shop/putShopCategory', {
        pageId: this.id,
        categories: this.list.filter(item => item.categoryId !== 'call-staff' && item.categoryId !== 'unknown').map(x => {
          if (x.subCategory && x.subCategory.length === 0) {
            delete x.subCategory
          }
          return x
        })
      })
      if (res) {
        alert(this.locale.complete_save)
        this.$emit('reload')
        this.close()
      } else {

      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.innerContent {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 30px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  background-color: $color-white;
}
.btns {
  margin-top: 30px;
  text-align: center;
}
.addCategory {
  display: flex;
  align-items: stretch;
  margin-bottom: 8px;
  .btn {
    margin-right: 4px;
  }
  .btnAdd {
    position: relative;
    height: 38px;
    border-style: dashed;
    background-color: $bg-default;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_plus.svg') 50% 50% / 12px no-repeat;
      opacity: 0.2;
    }
  }
}
</style>
